// extracted by mini-css-extract-plugin
export default {"container":"PaymentOptionList__container___jVxBN","item":"PaymentOptionList__item___FW2u4","icon":"PaymentOptionList__icon___RF7dm"};